import { Component, inject, input } from '@angular/core';
import { provideIcons, provideNgIconLoader, withCaching } from '@ng-icons/core';
import { heroPhoto } from '@ng-icons/heroicons/outline';
import { IconComponent } from '../icon/icon.component';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-image-cover',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './image-cover.component.html',
  styleUrl: './image-cover.component.scss',
  providers: [
    provideIcons({
      heroPhoto,
    }),
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
  ],
})
export class ImageCoverComponent {
  url = input.required<string | null>();
  placeholderIconName = input<string>('heroPhoto');
}
